// extracted by mini-css-extract-plugin
module.exports = {"disabled":"Menu_disabled__fkDK9","enabled":"Menu_enabled__tARF1"};